import { render, staticRenderFns } from "./GeneralReceiptList.vue?vue&type=template&id=3b8c22e0"
import script from "./GeneralReceiptList.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports